export const ACTION_CONTAINER = 'actionsContainer';
export const MAX_TEXT_WIDTH = 'maxTextWidth';
